import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { ChangeDetectorRef } from '@angular/core';

interface IOptions {
  name: string;
  id: string;
  selected: boolean;
}
@Component({
  selector: 'app-credit-info',
  templateUrl: './credit-info.component.html',
  styleUrls: ['./credit-info.component.scss'],
})
export class CreditInfoComponent implements OnInit {

  options: IOptions[];
  creditInfo: any;
  selectedoption: boolean;
  formGroup: FormGroup;
  showOptions: boolean;
  creditList: any;
  index: number;
  editCredit = false;
  flag = true;
  private oldNumberInputValue = '';
  constructor(
    public copyService: CopyService,
    public helperService: HelpersService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private abreCuentasService: AbreCuentasService,
    private parameterService: ParametersService,
    private ref: ChangeDetectorRef,
  ) {
    this.headerService.show(true, false, true);
    this.formGroup = this.formBuilder.group({});
    this.showOptions = false;
    this.creditInfo = {
      type: '',
      number: '',
      amount: '',
    };
  }

  ngOnInit() {
    this.creditList = this.abreCuentasService.getCreditList();
    this.index = this.abreCuentasService.getCreditIndex();
    this.options = this.parameterService.getSetting(OpEnum.CREDIT_TYPE);
    this.editCredit = this.abreCuentasService.getEditCredit();
    let convert = '';
    if (this.editCredit) {
      convert = this.creditList[this.index].amount.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    }
    this.formGroup = new FormGroup({
      'input-value-credit': new FormControl(
        this.editCredit ?
          this.options.find((fil: any) => fil.name === this.creditList[this.index].type) : '',
        [Validators.required]),
      'number': new FormControl(
        this.editCredit ? this.creditList[this.index].number : '',
        [Validators.required, Validators.maxLength(11), Validators.pattern(/^[0-9]+$/)]),
      'amount': new FormControl(
        this.editCredit ? '$ ' + convert : '',
        [Validators.required]),
    });
    this.ref.detectChanges();
  }

  onInputNumber(event: any) {
    const regex = /^[\d\+\-\.\,]*$/;
    if (!regex.test(event.target.value)) {
      event.preventDefault();
      this.formGroup.controls.number.setValue(this.oldNumberInputValue);
    }
    this.oldNumberInputValue = this.formGroup.value.number;
  }

  selectOption(option: any) {
    if (option === '') {
      this.selectedoption = false;
      return;
    }
    this.showOptions = false;
    this.formGroup.controls['input-value-credit'].setValue(option.value);
    this.selectedoption = option.value;
  }

  updateValuemonto(event: any) {
    const value = event.target.value;
    const newvalue = this.helperService.currency(value);
    this.formGroup.controls['amount'].setValue(newvalue.clearValue);
    event.target.value = newvalue.format;
  }

  deleteCredit() {
    this.abreCuentasService.setDeleteCredit(true);
    this.navigationService.nextStep('200');
  }

  back() {
    try {
      this.creditInfo.type = this.creditList[this.index].type;
      this.creditInfo.number = this.creditList[this.index].number;
      this.creditInfo.amount = this.creditList[this.index].amount;
      this.abreCuentasService.setCreditInfo(this.creditInfo);
    } catch (error) {
      console.log(error);
    }
  }

  next() {
    this.creditInfo.type = this.formGroup.value['input-value-credit'].id;
    this.creditInfo.number = this.formGroup.controls.number.value;
    this.creditInfo.amount = this.formGroup.controls.amount.value.replace('$ ', '').replace(/[\.]/gm, '').replace(',', '.').replace(/\.$/, '');
    this.abreCuentasService.setCreditInfo(this.creditInfo);
    this.navigationService.nextStep('200');
  }

}
